export default {"src":"/_next/static/media/process-tracking-check.6decb386.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};